/**
 * Convierte un string base64 con prefijo data:... en un Blob.
 * @param dataUrl string base64 que comienza con "data:..."
 * @returns Blob
 */
export function base64DataUrlToBlob(dataUrl: string): string {
  // Extraer el mime type y el contenido base64
  const matches = dataUrl.match(/^data:(.+);base64,(.+)$/);
  if (!matches) {
    throw new Error('El string base64 no tiene el formato esperado.');
  }
  const mime = matches[1];
  const base64 = matches[2];

  // Decodificar base64 a bytes
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Crear y retornar el Blob
  const blob = new Blob([byteArray], { type: mime });
  const blobUrl = URL.createObjectURL(blob);
  return blobUrl
}
